import { create } from 'zustand'

interface InterestsState {
  slugs: Set<string>
  setAll: (slugs: string[]) => void
  toggle: (slug: string, interested: boolean) => void
  clear: () => void
}

export const useInterestsStore = create<InterestsState>((set) => ({
  slugs: new Set(),
  setAll: (slugs) => set({ slugs: new Set(slugs) }),
  toggle: (slug, interested) =>
    set((state) => {
      const next = new Set(state.slugs)
      if (interested) next.add(slug)
      else next.delete(slug)
      return { slugs: next }
    }),
  clear: () => set({ slugs: new Set() }),
}))
